module.exports = __webpack_public_path__ + "static/media/csv.d9280638.svg";